// extracted by mini-css-extract-plugin
export default {"canvasRightComCrop":"canvasRightComCrop_canvasRightComCrop__+RMbN","sizeTips":"canvasRightComCrop_sizeTips__S-Mut"};